export enum CampaignType {
  Programme = "PROGRAMME",
  Reward = "REWARD",
  DealReg = "DEALREG",
};
